import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { accountSettingData } from "../../../Redux/actions/settingActions";
import UserInterface from "../../Components/InnerLayout/UserInterface";
import Headerbar from "../../Components/InnerLayout/Headerbar";
import {
  uploadAccLogo,
  changeSettingValue,
  getInvoiceList,
  getInvoiceDetails,
} from "../../../Redux/actions";
import CropperModel from "../../Components/CropperModel";
import {
  checkArray,
  checkNull,
  isChildAccount,
  isPastFromToday,
  parseStringToDate,
} from "../../../helpers";
import moment from "moment";
import DatePicker from "react-datepicker";
import ModelContainer from "../../Components/ModelContainer";
import LoadingIcon from "../../Components/LoadingIcon";

const Account = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const account = useSelector((state) => state.settingReducer.account);
  const {
    invoice_list,
    invoice_detail,
    invoiceDetailModal,
    is_invoice_detail_modal_loading,
  } = useSelector((state) => state.settingReducer);
  const user_details = useSelector((state) => state.authReducer.user_details);

  const [cropperModal, setCropperModal] = useState(false);

  useEffect(() => {
    dispatch(accountSettingData());
    dispatch(getInvoiceList({}));
    return () => {
      dispatch(changeSettingValue("account", null));
      dispatch(changeSettingValue("invoice_list", []));
      dispatch(changeSettingValue("invoice_detail", null));
    };
  }, []);

  const [selectedFile, setSelectedFile] = useState(null);
  const [companySearch, setCompanySearch] = useState("");
  const [accountSearch, setAccountSearch] = useState("");

  const [invoiceFromDate, setInvoiceFromDate] = useState("");
  const [invoiceToDate, setInvoiceToDate] = useState("");
  const [invoiceIdSearch, setInvoiceIdSearch] = useState("");
  const [invoiceDetailId, setInvoiceDetailId] = useState("");

  const closeInvoiceDetailModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("invoiceDetailModal", value));
      if (!value) setInvoiceDetailId("");
    },
    [invoiceDetailModal]
  );

  const invoiceDetailHandler = (id) => {
    setInvoiceDetailId(id);
    dispatch(getInvoiceDetails(account?.merchant_id, id));
  };
  const invoiceSearchHandler = () => {
    const invoicePayload = {
      from_date: checkNull(invoiceFromDate, false)
        ? moment(invoiceFromDate).format("yyyy-MM-DD")
        : "",
      to_date: checkNull(invoiceToDate, false)
        ? moment(invoiceToDate).format("yyyy-MM-DD")
        : "",
      invoice_number: invoiceIdSearch,
    };
    dispatch(getInvoiceList(invoicePayload));
  };

  const invoiceSearchResetHandler = () => {
    setInvoiceFromDate("");
    setInvoiceToDate("");
    setInvoiceIdSearch("");
    dispatch(getInvoiceList({}));
  };

  const onFileChangeEvent = (event) => {
    if (event?.target?.files[0]) {
      setSelectedFile(event.target.files[0]);
      closeModal(true);
      event.target.value = null;
    }
  };

  const closeModal = useCallback(
    (value) => {
      setCropperModal(value);
    },
    [cropperModal]
  );

  const saveCroppedImage = useCallback((value) => {
    dispatch(uploadAccLogo({ file: value }));
    closeModal(false);
  }, []);

  const getAccountStatus = (acc) => {
    let res = null;
    if (
      checkNull(acc?.merchant?.merchant_purchased_plans?.expiry_date, false)
    ) {
      const expiryDate = isPastFromToday(
        acc?.merchant?.merchant_purchased_plans?.expiry_date
      );
      if (
        !expiryDate &&
        acc?.merchant?.merchant_purchased_plans?.is_trial == 1
      ) {
        res = (
          <td>
            {" "}
            <span class="green_tag"> Active </span>{" "}
          </td>
        );
      } else if (
        !expiryDate &&
        acc?.merchant?.merchant_purchased_plans?.is_trial == 0
      ) {
        res = (
          <td>
            {" "}
            <span class="green_tag"> Active </span>{" "}
          </td>
        );
      } else {
        res = (
          <td>
            {" "}
            <span class="reject"> Cancelled </span>{" "}
          </td>
        );
      }
    }
    return res;
  };

  const companySearchHandler = (item) => {
    let resp = true;
    if (checkNull(companySearch, false)) {
      let searchText = companySearch.toLowerCase();
      resp = false;
      if ("active".toLowerCase().includes(searchText)) {
        resp = true;
      } else if (
        checkNull(item?.company_tax_id, false) &&
        item?.company_tax_id.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(item?.merchant_balance_sheet?.balance_sheet_name, false) &&
        item?.merchant_balance_sheet?.balance_sheet_name
          .toLowerCase()
          .includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(item?.incorporation_date, false) &&
        parseStringToDate(item?.incorporation_date, undefined, "DD-MM-yyyy")
          .toLowerCase()
          .includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(item?.currency?.currency_name, false) &&
        item?.currency?.currency_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      }
    }
    return resp;
  };

  const accountSearchHandler = (acc) => {
    let resp = true;
    if (checkNull(accountSearch, false)) {
      let searchText = accountSearch.toLowerCase();
      resp = false;
      if (
        checkNull(acc?.merchant?.id, false) &&
        acc?.merchant?.id.toString().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(acc?.merchant?.account_name, false) &&
        acc?.merchant?.account_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(acc?.merchant?.incorporation_date, false) &&
        parseStringToDate(
          acc?.merchant?.incorporation_date,
          undefined,
          "DD/MM/yyyy"
        )
          .toLowerCase()
          .includes(searchText)
      ) {
        resp = true;
      } else if (
        checkNull(acc?.merchant?.company_name, false) &&
        acc?.merchant?.company_name.toLowerCase().includes(searchText)
      ) {
        resp = true;
      }
    }
    return resp;
  };

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content">
          <div className="container px-0">
            <div className="top-logos d-flex justify-content-start">
              <figure className="uploaded-logo">
                <span className="img_cloog">
                  <img
                    src={
                      checkNull(account?.merchant_data?.logo, false)
                        ? account?.merchant_data?.logo
                        : "/img/logo555.png"
                    }
                    id="mlogo"
                  />
                </span>
              </figure>
              <div className="col-xl-11 col-10">
                <h4 className="mb-0"> {account?.merchant_data?.account_name ?? ""} </h4>
                <div className="input-group shift_action">
                  <label
                    className="upload-icon upload-logo uploadlogo mt-0"
                    for="staff_file"
                  >
                    {" "}
                    <span> Upload logo</span>
                    <input
                      type="file"
                      name="staff_file"
                      id="staff_file"
                      className="inputfile inputfile-2"
                      data-multiple-caption="{count} files selected"
                      onChange={onFileChangeEvent}
                    />
                  </label>
                </div>
              </div>
              {/* <span
                className="upload-logo uploadlogo"
                onClick={() => closeModal(true)}
              >
                {" "}
                Upload logo{" "}
              </span> */}
              {/* <ImageCropper /> */}
            </div>

            <div className="top-header-sec">
              <div className="">
                <h4 className="event-alert"> Companies </h4>
                <p>
                  {" "}
                  The below are the Companies linked to this Group. You may edit
                  the Company Name from a given effective date to have the same
                  represented on Tax-related documentation.{" "}
                </p>
                <div className="row justify-content-start align-items-center w-100 mx-0">
                  <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                    {" "}
                    <div className="search-box mt-0">
                      <input
                        type="text"
                        placeholder="Search"
                        name="keyword"
                        id="CompanySearchTag"
                        value={companySearch}
                        onChange={(e) =>
                          setCompanySearch(e?.target?.value ?? "")
                        }
                        autocomplete="off"
                      />
                      <input type="button" onclick="return false;" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="shadowclass">
              <div className="invoiceList">
                <div className="row-fluid general-setting">
                  <div className="col-12">
                    <div className="table-responsive">
                      <table
                        width="100%"
                        cellspacing="0"
                        cellpadding="0"
                        className="checklist-table filterTable"
                      >
                        <thead>
                          <tr>
                            <th width="150"> Tax ID </th>
                            <th width="255"> Company Name </th>
                            <th width="15%"> Status </th>
                            <th width="25%"> Incorporation Date </th>
                            <th width="25%"> Currency </th>
                            {!isChildAccount(user_details) && (
                              <th className="action-td"> Action </th>
                            )}
                          </tr>
                        </thead>
                        <tbody>
                          {account?.merchantInfos &&
                            account?.merchantInfos.length > 0 &&
                            account?.merchantInfos
                              .filter((item) => companySearchHandler(item))
                              .map((merchantInfo) => {
                                return (
                                  <tr>
                                    <td>
                                      {" "}
                                      {merchantInfo?.company_tax_id ?? ""}{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      {merchantInfo?.merchant_balance_sheet
                                        ?.balance_sheet_name ?? ""}{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      <span class="green_tag">
                                        {" "}
                                        Active{" "}
                                      </span>{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      {checkNull(
                                        merchantInfo?.incorporation_date,
                                        false
                                      )
                                        ? parseStringToDate(
                                            merchantInfo?.incorporation_date,
                                            undefined,
                                            "DD-MM-yyyy"
                                          )
                                        : ""}
                                    </td>
                                    <td>
                                      {" "}
                                      {merchantInfo?.currency?.currency_name ??
                                        ""}{" "}
                                    </td>
                                    {!isChildAccount(user_details) && (
                                      <td className="action-td">
                                        {" "}
                                        <a
                                          class="circle_icon edit_tooltip"
                                          onClick={() =>
                                            history.push(
                                              "/settings/account-settings/company-settings/" +
                                                merchantInfo?.id
                                            )
                                          }
                                        >
                                          <i class="iconSprites edit-icon"></i>
                                        </a>{" "}
                                      </td>
                                    )}
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="top-header-sec">
              <div className="mt-3">
                <h4 className="event-alert"> Accounts </h4>
                <p>
                  The below are the GoGMGo Accounts linked to this Group. Here
                  you may add new Accounts, edit existing Account details, or
                  cancel your Account subscriptions.
                </p>
                <div class="row justify-content-between align-items-center w-100 mx-0">
                  <div className="col-lg-4 col-md-5 px-0 mb-3 mb-sm-0">
                    <form
                      id="AccountSettingsIndexForm"
                      method="get"
                      accept-charset="utf-8"
                    >
                      <div className="search-box mt-0">
                        <input
                          type="text"
                          placeholder="Search"
                          name="keyword"
                          id="CompanySearchTag"
                          value={accountSearch}
                          onChange={(e) => setAccountSearch(e?.target?.value)}
                          autocomplete="off"
                        />
                        <input type="button" onclick="return false;" />
                      </div>
                    </form>{" "}
                  </div>
                  <div class="col-sm-7 col-12 align-right px-0">
                    <div class="field align-right">
                      <button
                        class="btn green-btn-revert add-plus mx-0"
                        type="button"
                        onClick={() => history.push("/codes")}
                      >
                        <i class="i-icon"> </i> Add Account
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="shadowclass">
              <div className="invoiceList">
                <div className="row-fluid">
                  <div className="col-12">
                    <div
                      className="table-responsive"
                      id="account_list"
                    >
                      <table
                        width="100%"
                        cellspacing="0"
                        cellpadding="0"
                        className="checklist-table filterTable"
                      >
                        <thead>
                          <tr>
                            <th width="150"> Account ID </th>
                            <th width="255"> Account Name </th>
                            <th width="15%"> Status </th>
                            <th width="25%"> Incorporation Date </th>
                            <th width="25%"> Linked Company Name </th>
                            <th className="action-td"> Actions </th>
                          </tr>
                        </thead>
                        <tbody>
                          {account?.accounts &&
                            account?.accounts.length > 0 &&
                            account?.accounts
                              .filter((item) => accountSearchHandler(item))
                              .map((acc) => {
                                return (
                                  <tr className="order_row">
                                    <td className="invent-first-col">
                                      {" "}
                                      {acc?.merchant?.id ?? ""}{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      {acc?.merchant?.account_name ?? ""}
                                    </td>
                                    <td>{getAccountStatus(acc)}</td>
                                    <td>
                                      {" "}
                                      {checkNull(
                                        acc?.merchant?.incorporation_date,
                                        false
                                      )
                                        ? parseStringToDate(
                                            acc?.merchant?.incorporation_date,
                                            undefined,
                                            "DD/MM/yyyy"
                                          )
                                        : ""}{" "}
                                    </td>
                                    <td>
                                      {" "}
                                      {acc?.merchant?.company_name ?? ""}{" "}
                                    </td>
                                    <td className="action-td">
                                      {" "}
                                      <a
                                        onClick={() =>
                                          history.push(
                                            "/settings/account-management"
                                          )
                                        }
                                        className="circle_icon edit_tooltip"
                                      >
                                        <i className="iconSprites edit-icon"></i>
                                      </a>{" "}
                                    </td>
                                  </tr>
                                );
                              })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="top-header-sec">
              <div className="mt-3">
                <h4 className="event-alert"> Invoices </h4>
                <p>
                  The below are the Invoices linked to your GoGMGo Accounts.
                </p>
              </div>
            </div>
            <div className="row-fluid">
              <div className="col-12">
                <form id="invoice_filter_form">
                  <div className="shadowclass top_filters accountSettings row m-0">
                    <h4 className="event-alert"> Date Selection </h4>
                    <div className="col-12 px-0">
                      <div className="row mx-0 cal align-items-end">
                        <div className="arrow-right px-4 col-xl-2 col-sm-3 col-6 pl0">
                          <label for="from_date"> Start Date </label>
                          <div
                            className="date-input position-relative"
                            id="start_date"
                          >
                            <DatePicker
                              name="from_date"
                              autoComplete="new-password"
                              dateFormat="yyyy-MM-dd"
                              onChange={(val) => setInvoiceFromDate(val)}
                              selected={invoiceFromDate}
                            />
                            {/* <span className="add-on">
                              <i className="fa fa-calendar"></i>
                            </span> */}
                          </div>
                        </div>
                        <div className="px-4 col-xl-2 col-sm-3 col-6 pl0 pr-xs-0 pl-xs-3">
                          <label for="to_date"> End Date </label>
                          <div
                            className="date-input position-relative"
                            id="end_date"
                          >
                            <DatePicker
                              name="to_date"
                              autoComplete="new-password"
                              dateFormat="yyyy-MM-dd"
                              onChange={(val) => setInvoiceToDate(val)}
                              selected={invoiceToDate}
                            />
                            {/* <span className="add-on">
                              <i className="fa fa-calendar"></i>
                            </span> */}
                          </div>
                        </div>

                        <div className="col-xl-2 col-md-3 col-12 px-4 pl0 d-flex flex-wrap pr-xs-0 mt-3 mt-sm-0">
                          <label for="invoice_number" className="col-12">
                            {" "}
                            Invoice ID
                          </label>
                          <input
                            name="invoice_number"
                            type="text"
                            id="invoice_number"
                            onChange={(e) =>
                              setInvoiceIdSearch(e?.target?.value)
                            }
                            value={invoiceIdSearch}
                            className="select-forms col-12"
                          />
                        </div>

                        <div className="d-flex col px-4 pl0 mt-xl-0 mt-3">
                          <button
                            className="btn btn_btnblue"
                            id="invoice_filter_btn"
                            type="button"
                            onClick={() => invoiceSearchHandler()}
                          >
                            Search
                          </button>
                          <button
                            className="btn cancel"
                            type="button"
                            id="invoice_filter_reset_btn"
                            onClick={() => invoiceSearchResetHandler()}
                          >
                            Reset
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="shadowclass mt-3">
              <div className="invoiceList">
                <div className="row-fluid general-setting">
                  <div className="col-12">
                    <div className="table-responsive">
                      <table
                        width="100%"
                        cellspacing="0"
                        cellpadding="0"
                        className="checklist-table remove-space inventory_table"
                        id="invoice_list_table"
                      >
                        <thead>
                          <tr>
                            <th width="150"> Date </th>
                            <th width="255"> Invoice ID </th>
                            <th width="15%"> Account Name </th>
                            <th width="25%"> Company Name </th>
                            <th width="25%"> Amount Paid </th>
                            <th className="action-td"> Actions </th>
                          </tr>
                        </thead>
                        {/* <tbody id="invoice_list_table_body"></tbody> */}

                        <tbody>
                          {checkArray(invoice_list) &&
                            invoice_list.map((invoice) => {
                              return (
                                <tr>
                                  <td class="invent-first-col">
                                    {" "}
                                    {invoice?.created ?? ""}{" "}
                                  </td>
                                  <td> {invoice?.id ?? ""} </td>
                                  <td> {invoice?.account_name ?? ""} </td>
                                  <td> {invoice?.company_name ?? ""} </td>
                                  <td> {invoice?.amount_paid ?? ""} </td>
                                  <td className="action-td">
                                    {" "}
                                    <a
                                      class="circle_icon showinvoice"
                                      role="button"
                                      onClick={() => {
                                        if (!is_invoice_detail_modal_loading)
                                          invoiceDetailHandler(invoice?.id);
                                      }}
                                    >
                                      {" "}
                                      <LoadingIcon
                                        is_loading={
                                          is_invoice_detail_modal_loading &&
                                          invoice?.id == invoiceDetailId
                                        }
                                        className="iconSprites eye-icon"
                                      />
                                    </a>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CropperModel
        open={cropperModal}
        submitModal={saveCroppedImage}
        closeModal={closeModal}
        is_loading={false}
        selectedFile={selectedFile}
      />
      <ModelContainer
        title={`Invoice`}
        open={invoiceDetailModal}
        closeModal={closeInvoiceDetailModal}
        is_loading={false}
      >
        <fieldset class="">
          <div class="user_details">
            {account?.merchant?.email} on GOGMGO subscription{" "}
            {invoice_detail?.invoice?.lines?.data?.[0]?.plan?.nickname ?? ""}
          </div>

          <h3 class="event-alert noborder">Pricing </h3>
          <div class="table-responsive p-0">
            <table
              width="100%"
              cellspacing="0"
              cellpadding="0"
              class="checklist-table remove-space inventory_table custom_tale_border mb-0"
            >
              <thead>
                <tr>
                  <th>Pricing Plan</th>
                  <th className="align-right">QTY</th>
                  <th className="align-right">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="border-bottm_1">
                    <strong>
                      GOGMGO Subscription{" "}
                      {invoice_detail?.invoice?.lines?.data?.[0]?.plan
                        ?.nickname ?? ""}{" "}
                    </strong>
                    <br />
                    <span class="small_font">
                      Date:{" "}
                      {checkNull(
                        invoice_detail?.invoice?.lines?.data?.[0]?.period
                          ?.start,
                        false
                      )
                        ? moment
                            .unix(
                              invoice_detail?.invoice?.lines?.data?.[0]?.period
                                ?.start
                            )
                            .format("MM-DD-yyyy")
                        : ""}
                    </span>
                  </td>
                  <td class="border-bottm_1" align="right">
                    1
                  </td>
                  <td class="border-bottm_1" align="right">
                    $
                    {checkNull(invoice_detail?.invoice?.amount_paid, false)
                      ? (
                          parseFloat(invoice_detail?.invoice?.amount_paid, 2) /
                          100
                        ).toFixed(2)
                      : "0.00"}
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td align="right">
                    <strong>Subtotal</strong>
                  </td>
                  <td align="right">
                    <strong>
                      $
                      {checkNull(invoice_detail?.invoice?.amount_paid, false)
                        ? (
                            parseFloat(
                              invoice_detail?.invoice?.amount_paid,
                              2
                            ) / 100
                          ).toFixed(2)
                        : "0.00"}
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td align="right">
                    <strong>Total</strong>
                  </td>
                  <td align="right">
                    <strong>
                      $
                      {checkNull(invoice_detail?.invoice?.amount_paid, false)
                        ? (
                            parseFloat(
                              invoice_detail?.invoice?.amount_paid,
                              2
                            ) / 100
                          ).toFixed(2)
                        : "0.00"}
                    </strong>
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td align="right">
                    <strong>Amount Due</strong>
                  </td>
                  <td align="right">
                    <strong>
                      $
                      {checkNull(invoice_detail?.invoice?.amount_paid, false)
                        ? (
                            parseFloat(
                              invoice_detail?.invoice?.amount_paid,
                              2
                            ) / 100
                          ).toFixed(2)
                        : "0.00"}
                    </strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </fieldset>
      </ModelContainer>
    </UserInterface>
  );
};
export default Account;
